<template>
    <v-dialog  persistent  v-model="dialog" width="60%">      
      <v-card v-show="!showEventView">
        <v-card-title class="grey lighten-3" >
            <tool-tip-icon style="margin-right:4px;"  v-if="assetMode" :text="`Deze point of interest is na opslaan beschikbaar voor alle assets`"></tool-tip-icon>
            <label>Point of interest&nbsp;</label>
            <label v-html="mutationType"></label>            
            <v-spacer></v-spacer>            
            <v-icon dark class="fas fa-times" style="color:#1C1C1C" @click="cancelGeoZone()"></v-icon>            
        </v-card-title>        
        <v-card-text>
            <v-layout>                
                <v-flex sm6 v-show="selectedTab!=2">
                    <v-layout column class="d-flex" align-content-space-between>
                        <v-flex sm12 d-flex class="grey lighten-4 py-2 px-2" style="border-bottom:1px solid #797979 !important" >
                            <v-flex sm6 class="dd-justify-center" >
                                <div class="dd-label">Oppervlakte</div>
                                <div class="dd-value">{{squareMeasureHumanReadable}}</div>                                
                            </v-flex>
                            <v-flex sm6 class="dd-justify-center" >
                                <div class="dd-label">Omtrek</div>
                                <div class="dd-value">{{lineDistanceHumanReadable}}</div>                                
                            </v-flex>
                        </v-flex>                           
                        <l-map    
                            ref="saveGeoMap"                    
                            :zoom="zoom"                            
                            :options="mapOptions"
                            :bounds="bounds"
                            style="min-height:358px;"                              
                            >
                               
                            <l-tilelayer :url="url" :attribution="attribution"></l-tilelayer>   
                        </l-map>
                        <div class="polybar success white--text" v-if="validPoly">Point of interest is correct</div>
                        <div class="polybar error white--text" v-else>Point of interest is niet correct</div>                     
                    </v-layout>
                </v-flex>
                <v-flex :class="tabWidth" ml-2>       
                    <v-tabs v-model="selectedTab" grow>
                      <v-tab key="group_form">Algemeen</v-tab>
                      <v-tab key="extra_fields"  :disabled="newGeoZoneMode">Extra velden</v-tab>
                      <v-tab key="poi"  :disabled="newGeoZoneMode">assetgroepen op POI</v-tab>
                    </v-tabs>                    
                    <v-tabs-items v-model="selectedTab">
                    <!-- GENERAL TAB --------------------------------------------------------->
                        <v-tab-item key="group_form">     
                            <v-flex v-if="newGeoZoneMode" secondary pa-1 ml-1 mr-2 mt-1 white--text>
                                <i class="far fa-exclamation-circle"></i>
                                Extra velden en assetgroepen kunnen toegevoegd worden na het aanmaken van Point of interest
                            </v-flex> 
                            <v-form
                                ref="geoZoneForm"
                                v-model="formValid"
                                lazy-validation>                            
                                <v-flex class="py-2 px-2">
                                    <v-flex sm12> 
                                        <v-text-field
                                            label="Naam voor Point of interest"
                                            hint="Omschrijving voor uw point of interest"                                
                                            :rules="[formRules.name]"   
                                            v-model="name"
                                            
                                            required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex>                            
                                        <v-select 
                                        item-value="id"
                                        item-text="name"                                 
                                        :items="geoZoneTypes"
                                        label="Type point of interest"
                                        :rules="[formRules.type]"                                   
                                        v-model="geoZoneTypeId"
                                        required
                                        ></v-select>    
                                    </v-flex>                                
                                    <v-flex>
                                        <v-textarea
                                            name="input-7-1"
                                            label="Omschrijving"
                                            value=""
                                            v-model="description"
                                            hint="Optionele omschrijving en/of opmerkingen voor uw poi"
                                            ></v-textarea>
                                    </v-flex>                      
                                </v-flex>   
                                <v-spacer></v-spacer>              
                                <v-flex mt-3 pl-2 pr-2>                            
                                    <v-btn v-if="id" @click="editGeoZoneOpMap()"  block>Point of interest bewerken op kaart</v-btn>
                                </v-flex>                                           
                                <v-flex class="py-2" d-flex>
                                    <v-btn @click="cancelGeoZone()">Annuleren</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="deleteDialog=true">
                                        <!-- <tool-tip-icon :text="`Point of interest verwijderen`"> -->
                                        <i class="fas fa-trash"></i></v-btn> 
                                        <!-- </tool-tip-icon> -->
                                    <v-spacer></v-spacer>
                                    <v-btn color="success" @click="saveGeoZone()">Opslaan</v-btn>
                                </v-flex>                               
                            </v-form>     
                        </v-tab-item>    
                        <v-tab-item key="extra_fields">                                    
                            <v-flex sm12 lg12 mt-4 >
                                <v-flex pa-2>
                                    <custom-fields 
                                        :customFields="customFieldsOnGeoZone" 
                                        v-model="selectedCustomFields" 
                                    >
                                    </custom-fields>             
                                </v-flex>                      
                            </v-flex>    
                            <v-flex xs12 right>                                
                                <v-btn color="success" @click="saveCustomFields()">Opslaan</v-btn>                                  
                            </v-flex>                                                        
                        </v-tab-item>
                        <v-tab-item key="poi">      
                            <asset-group-events-on-geo-zone v-if="!newGeoZoneMode" :geoZone="geoZone" allowNew="1"></asset-group-events-on-geo-zone>                      
                        </v-tab-item>    
                    </v-tabs-items>                
                </v-flex>
            </v-layout>
        </v-card-text>
      </v-card>
      <v-dialog  persistent  v-model="deleteDialog"  width="40%">      
        <v-card>
            <v-card-title class="grey lighten-3" >                
                <label>Point of interest&nbsp;verwijderen</label>
                <v-spacer></v-spacer>            
                <v-icon dark class="fas fa-times" style="color:#1C1C1C" @click="deleteDialog=false"></v-icon>            
            </v-card-title>         
            <v-card-text>
                Weet u zeker dat u Point of interest met naam "{{name}}" wilt verwijderen </br>
                </br>
                Let op! Ook alle ingestelde events voor deze POI zullen verwijderd worden.</br>
                Alle in het verleden getriggerde events blijven bestaan.                
            </v-card-text>      

            <v-flex class="py-2" d-flex>
                <v-btn @click="deleteDialog=false">Annuleren</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="deleteGeoZone()">Verwijderen</v-btn>
            </v-flex>           
        </v-card>
      </v-dialog>
      <!-----
      <v-card v-if="showEventView">
        <v-card-title class="grey lighten-3" >
            <label>Event geozone {{eventTypeLabel}} {{eventMutationMode}}</label>
            <v-spacer></v-spacer>            
            <v-icon dark class="fas fa-times" style="color:#1C1C1C" @click="cancelGeoZone()"></v-icon>            
        </v-card-title>       
        <event-form :unitTypeEvent="selectedUnitTypeEvent" 
                    @saved="saveEventOnGeozone" 
                    @cancelClicked="cancelEventEditing" 
                    :hideWorkFlowButton="true"
                    :withUnitTypeSelector="true"></event-form>
      </v-card>
      -->
    </v-dialog>
</template>
<script>
//import { mapGetters } from 'vuex'
import * as types from "../../store/types"
import { mapGetters } from 'vuex'
import MapMixin from '../../plugins/mixins/MapMixin'
import AssetGroupEventsOnGeoZone from '../../components/asset/AssetGroupEventsOnGeoZone'
import eventForm from "../../components/event/unitTypeEventForm"
import toolTipIcon from "../../components/global/ToolTipIcon"
import CustomFields from "../../components/form/CustomFields"
import length from '@turf/length'
import area from '@turf/area'

export default{
    props:['polyPoints', 'color', 'geoZone', 'asset'],
    mixins: [MapMixin],
    components:{
        CustomFields,
        eventForm,
        toolTipIcon,
        AssetGroupEventsOnGeoZone
    },
    data(){
        return {
            formValid:true,
            formRules:{
                name:(value) => {return (value) ? true : "Veld verplicht"},
                type:(value) => {return (value) ? true : "Veld verplicht"}
            },
            deleteDialog:false,
            selectedTab:0,
            geoZoneTypeId:null,
            eventUpdateType:"",
            selectedUnitTypeEvent:null,
            eventType:"",
            showEventView:false,
            dialog: true, 
            geoJSON: null,
            squareMeasure: null,
            lineDistance: null,
            id:null,
            name:'',
            description: '',
            selectedCustomFields:{}            
            // bounds: null
            
        }
    },
    computed:{
        ...mapGetters({
            geoZoneTypes: types.GEO_ZONE_TYPES,       
            geoZoneCustomFields: types.GEO_ZONE_CUSTOM_FIELDS,      
        }),     
        newGeoZoneMode(){
            return this.id ? false : true
        },
        customFieldsOnGeoZone(){
            let custom = []
            this.geoZoneCustomFields.forEach((field) => {
                custom.push(field.customField)
            })
            return custom
        },   
        tabWidth(){
            return this.selectedTab == 2 ? "sm12" : "sm6"
        },
        assetMode(){
            return this.asset ? true : false
        },
        mutationType(){
            if(this.assetMode)
                return "&nbsp; met event aanmaken voor <b>"+this.asset.name+"</b>"
            else
                return this.id ? 'wijzigen' : 'opslaan'
        },
        eventTypeLabel(){
            return this.eventType == "enter" ? "binnenkomen" : "verlaten"
        },
        validPoly(){
            return true
        },     
        lineDistanceHumanReadable(){
            if(this.lineDistance > 1){
                return `${this.lineDistance} km`
            }
            else{
                return `${(this.lineDistance * 1000)} meter`
            }
        },
        squareMeasureHumanReadable(){
            if(this.squareMeasure < 1000000){
                return `${this.squareMeasure} m2`
            }
            else{
                return `${(this.squareMeasure / 1000 / 1000).toFixed(1)} km2`
            }
        },
        eventMutationMode(){
            return "bewerken"
        },
        enterEvent(){
            return (this.id && this.geoZone.geoZoneEvent && this.geoZone.geoZoneEvent.enterEvent) ? this.geoZone.geoZoneEvent.enterEvent : null
        },
        exitEvent(){
            return (this.id && this.geoZone.geoZoneEvent && this.geoZone.geoZoneEvent.exitEvent) ? this.geoZone.geoZoneEvent.exitEvent : null
        }    
    },   
    methods:{
        saveCustomFields(){
            let obj = _.pickBy(this.selectedCustomFields, (ele) => ele != undefined)
            this.$store.dispatch(types.SAVE_GEO_ZONE_CUSTOM_FIELD_VALUES, {data: { geoZoneId: this.geoZone.id, fields: obj } }).then( () => {
                this.$emit('geoZoneSaved', {})
                this.$notify('Extra velden zijn opgeslagen', {type: 'success', icon: 'check'})   
            })
                                              
        },
        editGeoZoneOpMap(){
            this.$emit('editGeoZoneOnMap')
        },
        saveGeoZone(){
            if (this.$refs.geoZoneForm.validate()) {                    
                this.$store.dispatch(types.SAVE_GEO_ZONE, {data: { id:this.id , name: this.name, description: this.description, shapeType:"polygon", geoZoneTypeId:this.geoZoneTypeId ,geojson: this.geoJSON, shapeData:this.geoJson }}).then((res) => {
                    this.$notify('Point of interest is opgeslagen',{type: 'success', 'icon': 'checked'})
                    this.$emit('geoZoneSaved', res)
                })
            }
        },
        cancelGeoZone(){
            this.$emit('geoZoneCanceled', true)
        },
        addAssetGroupToPoi(){
            this.$emit('openPoiWizard', this.geoZone)
        },
        cancelEventEditing(){
            this.eventUpdateType=""
            this.selectedUnitTypeEvent=null
            this.showEventView=false
        },
        /*
        saveEventOnGeozone(event){
            let save = false
            // geozoneEvent is known so dont have to save anything
            if(this.selectedUnitTypeEvent){
                 this.$notify(`Point of interest event ${this.selectedUnitTypeEvent.name} aangepast`, {type: 'success', icon: 'check'})
            }
            // add unitType event to geoZoneEvent
            else if(this.id){
                let store = {}                                
                if(this.geoZone.geoZoneEvent)
                    store.geoZoneEventId = this.geoZone.geoZoneEvent.id
                else
                    store.geoZoneId      = this.id
                                            
                if(this.eventType == "enter"){
                    if(!this.geoZone.geoZoneEvent || !this.geoZone.geoZoneEvent.enterEvent){
                        save=true;
                        store.onEnterUnitTypeEventId = event.id;
                    }                    
                }
                if(this.eventType == "exit"){
                    if(!this.geoZone.geoZoneEvent || !this.geoZone.geoZoneEvent.exitEvent){
                        save=true;
                        store.onExitUnitTypeEventId = event.id;
                    } 
                }
                if(save){                        
                    this.$store.dispatch(types.SAVE_GEO_ZONE_EVENT, {data:store} ).then((e) => { });                                            
                }           
            }

            // always close edit screen and emit eventsaved event
            this.cancelEventEditing();
            this.$emit('eventSavedOnGeoZone');   
        },
        */
        loadGeoZoneTypes(){
            if(this.geoZoneTypes.length==0){
                    this.$store.dispatch(types.GEO_ZONE_TYPES,{})
            }
        },
        loadGeoZoneCustomFields(){
            this.$store.dispatch(types.GEO_ZONE_CUSTOM_FIELDS,{params:{include:"customField, customField.type"}}).then(() => {})
        },
        deleteGeoZone(){
            this.$store.dispatch(types.DELETE_GEO_ZONE, {data: { id:this.id }} ).then((res) => {
                this.$emit('geoZoneDeleted', res)
            })            
        }
    },
    mounted(){
        this.loadGeoZoneTypes();
        this.loadGeoZoneCustomFields();

        if(this.geoZone){            
            this.id            = this.geoZone.id;
            this.name          = this.geoZone.name;            
            this.description   = this.geoZone.description;
            this.geoZoneTypeId = this.geoZone.geoZoneType.id;

            if(this.geoZone.customFieldValues){
                this.geoZone.customFieldValues.forEach((field) => {
                    this.selectedCustomFields[field.name] = field.value
                })
            }
        }
        
        let vm = this
        this.$nextTick(() => {            
            vm.mapCenter = [52,6]
            let map = vm.$refs['saveGeoMap'];       
            let polygon = L.polygon(vm.polyPoints).addTo(map.mapObject);          
            vm.geoJSON = polygon.toGeoJSON()
            vm.squareMeasure = (area(this.geoJSON) ).toFixed(2)
            vm.lineDistance = (length(this.geoJSON, {units: 'kilometers'}).toFixed(2))
            vm.bounds = vm.polyPoints
            //vm.squareKm = (area(this.geoJSON) / 1000).toFixed(2);            
            
        })                
    }
}
</script>
<style>
    .polybar {
        padding: 4px 4px;
        display: flex;
        text-align: 'center';
        justify-content: center
    }

    
</style>
